import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc73ac86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tips-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.75 3.75V14.25L6.75 11.25H4.5C4.30109 11.25 4.11032 11.171 3.96967 11.0303C3.82902 10.8897 3.75 10.6989 3.75 10.5V7.5C3.75 7.30109 3.82902 7.11032 3.96967 6.96967C4.11032 6.82902 4.30109 6.75 4.5 6.75H6.75L9.75 3.75Z",
    stroke: "#F7981C",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.1553 6.345C13.5045 6.69334 13.7816 7.10716 13.9706 7.56275C14.1597 8.01834 14.257 8.50675 14.257 9C14.257 9.49326 14.1597 9.98166 13.9706 10.4373C13.7816 10.8928 13.5045 11.3067 13.1553 11.655",
    stroke: "#F7981C",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "建议前往推荐的服务站点就近维修", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import {} from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'network-header-tips',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}
}

})